import React from 'react'
import Header from './components/Header'
import Copywrite from './components/copywrite'
import Footer from '../../components/Footer'
import DataWrapper from './components/DataWrapper'

const Contact = () => {
    return (
        <div>
            <Header Title="Contact Us" lastUpdated="Last Updated on January 1st, 2025" />
            <div className='md:p-12 p-6 max-w-7xl mx-auto'>
                <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-bold leading-[26px] mb-[15px]">
                    Email: <a href='support@herbalteatherapy.com' className='font-normal text-blue-600 hover:underline'>support@herbalteatherapy.com</a>
                </p>
                <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
                    CUSTOMER SERVICE HOURS:
                </p>
                <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
                    10am - 5pm EST (Monday-Friday)</p>
                <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
                    2pm-5pm EST (Saturday & Sunday)
                </p>
                <p className="text-[#181818] font-['Myriad_Pro'] text-[18px] font-normal leading-[26px] mb-[15px]">
                    Customer Support Number: +1 (330) 521-3590
                </p>
                <div className='flex items-center justify-center w-full'>
                    <Copywrite />
                </div>
            </div>
        </div>
    )
}

export default Contact
